//-- Copyright (c) 2021 TMT Insights Group, LLC
import PolarisIcon from '@/components/_common/PolarisIcon';
import styled from '@emotion/styled';
import { IconButton, TableCell } from '@mui/material';
import { MouseEventHandler } from 'react';
import { Overlay } from './TableRow';

type TableExpandCellProps = {
  isCollapsed: boolean;
  setIsCollapsed: (isCollapsed: boolean) => void;
  disabled?: boolean;
  scrollable: boolean;
  scrollEnd: 'left' | 'right' | null;
};

export const TableExpandCell = ({ isCollapsed, setIsCollapsed, disabled = false, scrollable, scrollEnd }: TableExpandCellProps) => {
  const handleSetOpen: MouseEventHandler = (e) => {
    e.stopPropagation();
    setIsCollapsed(!isCollapsed);
  };

  return (
    <Wrapper className="expandable">
      {scrollable && scrollEnd !== 'left' && <Overlay className="overlay-right" position="right" />}

      {!disabled && (
        <>
          <IconButton onClick={handleSetOpen} size="small" aria-label="expand row">
            <ExpandableIcon icon="down" collapsed={+isCollapsed} height={15} />
          </IconButton>
        </>
      )}
    </Wrapper>
  );
};

export default TableExpandCell;

const Wrapper = styled(TableCell)`
  position: relative;
  width: 30px;
  padding: ${({ theme }) => theme.spacing(0, 0, 0, 1)};
`;

const ExpandableIcon = styled(PolarisIcon)<{ collapsed: number }>`
  opacity: ${({ collapsed }) => (collapsed ? 0.6 : 1)};
  color: ${({ theme, collapsed }) => (collapsed ? theme.palette.text.primary : theme.palette.primary.main)};
  &:hover {
    opacity: 1;
  }

  ${({ collapsed }) => collapsed && 'transform: rotate(-90deg);'}
`;
